module.exports = __webpack_public_path__ + "img/step-backward.518d3afe.svg";